'use strict';

const mmWidgets  = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	GoldAWSApi = require('../models/gold-aws-api'),
	ActivityLog = require('../models/activity-log'),
	S3Api = require('../models/s3-api'),
	AjaxPromise = require('../models/ajax-promise'),
	GoldFunnelModel = require('../models/gold-funnel-model'),
	TaskRetrier = require('../models/task-retrier'),
	AjaxNetworkErrorRetrier = require('../models/ajax-network-error-retrier'),
	googleAjaxErrorConverter = require('../models/google-ajax-error-converter'),
	GoogleDriveService = require('../models/google-drive-service'),
	FileContextDispatcher = require('../models/file-context-dispatcher'),
	GoogleDriveResumableUploader = require('../models/google-drive-resumable-uploader'),
	FormatConverter = require('../models/format-converter'),
	freemindImport = require('../widgets/freemind-import'),
	IconEditorController = require('../models/icon-editor-controller'),
	domImageDimensionCalculator = require('../widgets/dom-image-dimension-calculator'),
	WriterModel = require('../models/writer-model'),
	AttachmentEditorController = require('../models/attachment-editor-controller'),
	NetworkStatusDispatcher = require('../models/network-status-dispatcher'),
	IconLocaliser = require('../models/icon-localiser'),
	StoryboardModel = require('../models/storyboard-model'),
	StoryboardDimensionProvider = require('../models/storyboard-dimension-provider'),
	StoryboardController = require('../models/storyboard-controller'),
	StoryboardMapMediator = require('../models/storyboard-map-mediator'),
	storyboardFontSize = require('../widgets/storyboard-font-size'),
	LoginHintAuthenticator = require('../models/login-hint-authenticator'),
	GooglePicker = require('../models/google-picker'),
	CopyFileController = require('../models/copy-file-controller'),
	GoogleDriveFilePageController = require('../models/google-drive-file-page-controller'),
	GoogleFileEditingSession = require('../models/google-file-editing-session'),
	ThumbnailBuilder = require('../widgets/thumbnail-builder'),
	GoogleImagePicker = require('../models/google-image-picker'),
	CorsProxyFallbackDownloader = require('../models/cors-proxy-fallback-downloader'),
	GoogleAttachmentPicker = require('../models/google-attachment-picker'),
	googleTokenRefresher = require('../models/google-token-refresher'),
	initialRenameMediator = require('../models/initial-rename-mediator'),
	GoogleDriveImportModel = require('../models/google-drive-import-model'),
	ajaxBlobFetch = require('../models/ajax-blob-fetch'),
	defaultMapContent = require('../models/default-map-content'),
	authenticationDriveStart = require('../features/authentication/authentication-drive-start'),
	GoldAttachmentUnpacker = require('../models/gold-attachment-unpacker'),
	GoldIconUnpacker = require('../models/gold-icon-unpacker'),
	AssetLocaliser = require('../models/asset-localiser'),
	progressStart = require('../features/progress/progress-start'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	personalSignupStart = require('../features/signup/personal-signup-start'),
	ConfigurationGenerator = require('../models/configuration-generator'),
	ContextMenuModel = require('../models/context-menu-model'),
	mapEditingStart = require('../features/map-editing/map-editing-start'),
	mapViewingStart = require('../features/map-viewing/map-viewing-start'),
	mapExportsStart = require('../features/map-exports/map-exports-start'),
	measuresStart = require('../features/measures/measures-start'),
	pageActionsStart = require('../features/page-actions-start'),
	formatNoteToHtml = require('@mindmup/mapjs').formatNoteToHtml,
	JsonStorage = require('../models/json-storage'),
	getStorage = require('../models/get-storage'),
	UnsavedChangesModel = require('../models/unsaved-changes-model'),
	GoogleDriveAutosaver = require('../models/google-drive-autosaver'),
	clipboardStart = require('../features/clipboard-start'),
	GoogleMapCreatorModel = require('../models/google-map-creator-model'),
	CollaborationModel = require('../models/collaboration-model'),
	plans = require('../models/plans'),
	GapiScriptLoader = require('../models/gapi-script-loader'),
	ConfirmationSender = require('../models/confirmation-sender'),
	AjaxPromiseErrorAdapter = require('../models/ajax-promise-error-adapter'),
	LinkedSubmapController = require('../models/linked-submap-controller'),
	{ initGAConsent } = require('./ga-consent');

require('../widgets/send-to-google-widget');
require('../widgets/contact-link-widget');
require('../widgets/page-scroll-key-override');
require('../widgets/popup-link-widget');
require('../widgets/show-hotkey-widget');
require('../widgets/tabbed-section-widget');
require('../widgets/add-measure-widget');
require('../widgets/attachment-editor-widget');
require('../widgets/blob-downloader-link-widget');
require('../widgets/context-disabler-widget');
require('../widgets/node-context-widget');
require('../widgets/input-focus-widget');
require('../widgets/download-link-widget');
require('../widgets/copy-file-widget');
require('../widgets/context-menu-widget');
require('../widgets/drive-share-dialog');
require('../widgets/file-name-widget');
require('../widgets/full-screen-view-widget');
require('../widgets/storyboard-key-handler-widget');
require('../widgets/storyboard-widget');
require('../widgets/icon-editor-widget');
require('../widgets/install-hotkey-widget');
require('../widgets/menu-bar-widget');
require('../widgets/sidebar-widget');
require('../widgets/search-widget');
require('../widgets/selectable-readonly-input-widget');
require('../widgets/macify-hotkeys-widget');
require('../widgets/keyboard-color-widget');
require('../widgets/move-to-folder-widget');
require('../widgets/writer-widget');
require('../widgets/splittable-widget');
require('../widgets/subscription-profile-widget');
require('../widgets/google-file-confirmation-widget');
require('../widgets/keydown-toggle-widget');
require('../widgets/send-activity-log-widget');


module.exports = function () {
	const navigatorShim = new NavigatorShim(),
		activityLog = new ActivityLog(1000),
		browserStorage = getStorage(window),
		storage = new JsonStorage(browserStorage),
		ajaxPromise = new AjaxPromise(navigatorShim),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes), true),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationDriveStart(config, navigatorShim, ajaxPromise, goldApi),
		configurationGenerator = new ConfigurationGenerator(goldApi, authentication.authenticationModel),
		collaborationModel = new CollaborationModel(),
		mapViewing = mapViewingStart(config, activityLog, navigatorShim, collaborationModel),
		version = navigatorShim.getMMVersion(),
		mapEditing = mapEditingStart(Object.assign({config, ajaxPromise, storage, version}, mapViewing)),
		container = document.querySelector('mapeditor'),
		taskRetrier = new TaskRetrier(navigatorShim),
		googleAjaxProvider = new AjaxPromiseErrorAdapter(ajaxPromise, googleAjaxErrorConverter),
		googleAjaxNetworkErrorRetrier = new AjaxNetworkErrorRetrier(3, googleAjaxProvider, taskRetrier),
		googleDriveService = new GoogleDriveService(googleAjaxNetworkErrorRetrier, authentication.googleShim, new GoogleDriveResumableUploader({activityLog: activityLog}), navigatorShim),
		imageLoginHint = function () { // has to be like this due to a circular dependency
			return googlePageController.getLoginHint(); // eslint-disable-line no-use-before-define
		},
		iconAuthenticator = new LoginHintAuthenticator(authentication.imageAuthenticator, imageLoginHint),
		formatConverter = new FormatConverter(freemindImport, true),
		unsavedChangesModel = new UnsavedChangesModel(navigatorShim, mapViewing.collaborationModel, storage),
		corsProxyFallbackDownloader = new CorsProxyFallbackDownloader(config, navigatorShim, ajaxPromise, '/assets/image-placeholder.svg'),
		thumbnailBuilder = new ThumbnailBuilder(config, () => Promise.resolve(mapViewing.collaborationModel.getActiveContentClone()), navigatorShim, corsProxyFallbackDownloader, mapViewing.themeProvider, mapViewing.mapModel),
		googleFileEditingSession = new GoogleFileEditingSession(googleDriveService, mapViewing.collaborationModel, formatConverter, unsavedChangesModel, thumbnailBuilder.build, {activityLog: activityLog}),
		gapiScriptLoader = new GapiScriptLoader(config, window, navigatorShim),
		googlePageController = new GoogleDriveFilePageController(config, gapiScriptLoader, navigatorShim, authentication.authenticationModel, googleDriveService, formatConverter, authentication.googleAuthenticator, googleFileEditingSession, defaultMapContent, activityLog), //mapViewing.collaborationModel, defaultMapContent),
		fileContextDispatcher = new FileContextDispatcher(config, googlePageController, navigatorShim, googleFileEditingSession),
		googlePicker = new GooglePicker(config,  window),
		googleFileModel = {createFile: googleDriveService.createPlainFile},
		copyFileController = new CopyFileController(config, googleFileModel, mapViewing.collaborationModel.getActiveContent, googlePageController),
		googleImagePicker = new GoogleImagePicker(googlePicker, corsProxyFallbackDownloader, googleDriveService),
		progress = progressStart(mapViewing.mapModel, googleImagePicker, domImageDimensionCalculator, mapEditing.colorPickerModel, iconAuthenticator),
		iconEditorController = new IconEditorController(mapViewing.mapModel, googleImagePicker, domImageDimensionCalculator, iconAuthenticator),
		writerModel = new WriterModel(mapViewing.collaborationModel, mapViewing.mapModel, 'note'),
		attachmentPicker = new GoogleAttachmentPicker(googlePicker, authentication.authenticationModel),
		attachmentEditorController = new AttachmentEditorController(mapViewing.mapModel, attachmentPicker, navigatorShim, writerModel),
		networkStatusDispatcher = new NetworkStatusDispatcher(config, navigatorShim),
		iconLocaliser = new IconLocaliser(corsProxyFallbackDownloader),
		assetLocaliser = new AssetLocaliser([iconLocaliser.localiseSingleIcon]),
		measures = measuresStart(config, mapViewing.collaborationModel, mapViewing.mapModel, navigatorShim),
		storyboardModel = new StoryboardModel(mapViewing.collaborationModel, 'storyboards', 'storyboard-scenes'),
		storyboardDimensionProvider = new StoryboardDimensionProvider(storyboardFontSize),
		storyboardController = new StoryboardController(storyboardModel, mapViewing.mapModel),
		storyboardMapMediator = new StoryboardMapMediator(mapViewing.mapModel, storyboardController),
		goldFunnelModel = new GoldFunnelModel(activityLog),
		mapExports = mapExportsStart(config, configurationGenerator, s3Api, activityLog, goldFunnelModel, navigatorShim, mapViewing.collaborationModel, mapViewing.mapModel, mapViewing.themeProvider, iconLocaliser,  assetLocaliser, storyboardModel, storyboardDimensionProvider, ajaxPromise, authentication, goldApi, googlePageController, mapViewing.nodeViewModel, fileContextDispatcher),
		linkedSubmapController = new LinkedSubmapController(config, googleFileModel, mapExports.localMapContentExporter.makeExportable, mapEditing.mapEditorModel, navigatorShim),
		importModel = new GoogleDriveImportModel(authentication.authenticationModel, googlePicker, googlePageController),
		clipboard = clipboardStart(mapViewing.mapModel, mapViewing.mapThemeModel, {
			unpackers: [
				new GoldIconUnpacker(corsProxyFallbackDownloader, {unpackGoldOnly: true}),
				new GoldAttachmentUnpacker(navigatorShim)
			]
		}, navigatorShim),
		contextMenuModel = new ContextMenuModel(mapViewing.mapModel),
		wrappedAuthenticator = new LoginHintAuthenticator(authentication.googleAuthenticator, googlePageController.getLoginHint),
		googleDriveAutosaver = new GoogleDriveAutosaver(config, googlePageController, navigatorShim, unsavedChangesModel),
		mapCreatorModel = new GoogleMapCreatorModel(config, navigatorShim, authentication.googleAuthenticator, authentication.authenticationModel),
		confirmationSender = new ConfirmationSender({storage, goldApi, authenticationModel: authentication.authenticationModel, source: navigatorShim.getHostName()}),
		components = {
			activityLog: activityLog,
			contextMenuModel: contextMenuModel,
			argumentMappingModel: mapEditing.argumentMappingModel,
			attachmentEditorController: attachmentEditorController,
			authenticator: authentication.googleAuthenticator,
			authenticationModel: authentication.authenticationModel,
			clipboardModel: clipboard.clipboardModel,
			colorPickerModel: mapEditing.colorPickerModel,
			fontPickerModel: mapEditing.fontPickerModel,
			collaborationModel: mapViewing.collaborationModel,
			copyFileController: copyFileController,
			fileLoadedContextDispatcher: fileContextDispatcher,
			goldFunnelModel: goldFunnelModel,
			googleDriveService: googleDriveService,
			googleDriveAutosaver: googleDriveAutosaver,
			iconEditorController: iconEditorController,
			importModel: importModel,
			labelsModel: mapViewing.labelsModel,
			layoutExportController: mapExports.layoutExportController,
			localExportController: mapExports.localExportController,
			mapModel: mapViewing.mapModel,
			mapEditorModel: mapEditing.mapEditorModel,
			mapThemeModel: mapViewing.mapThemeModel,
			measuresModel: measures.measuresModel,
			networkStatusDispatcher: networkStatusDispatcher,
			navigatorShim: navigatorShim,
			pageController: googlePageController,
			progressModel: progress.progressModel,
			progressIconEditorController: progress.progressIconEditorController,
			progressIconPersister: progress.progressIconPersister,
			splittableModel: mapEditing.splittableModel,
			storyboardMapMediator: storyboardMapMediator,
			storyboardModel: storyboardModel,
			storyboardController: storyboardController,
			thumbnailBuilder: thumbnailBuilder,
			unsavedChangesModel: unsavedChangesModel,
			writerModel: writerModel,
			subscriptionModel: authentication.subscriptionModel,
			mapCreatorModel: mapCreatorModel,
			nodeStyleEditorModel: mapEditing.nodeStyleEditorModel,
			googleShim: authentication.googleShim,
			stickersEditorModel: mapEditing.stickersEditorModel,
			confirmationSender: confirmationSender,
			linkedSubmapController
		};

	mapViewing.collaborationModel.addEventListener('newSession', () => confirmationSender.confirm('map-loaded'));
	personalSignupStart(config, authentication.subscriptionModel, subscriptionPlanModel, authentication.authenticationModel, navigatorShim, s3Api, goldApi);
	initGAConsent(config);
	pageActionsStart(components, container);

	googleTokenRefresher(fileContextDispatcher, wrappedAuthenticator);

	mapViewing.collaborationModel.addEventListener('newSession', (idea) => {
		mapViewing.mapModel.setIdea(idea);
		progress.progressModel.bindContentListeners();
		mapViewing.mapModel.focusAndSelect(idea.getDefaultRootId());
	});
	initialRenameMediator(config, mapViewing.collaborationModel, googlePageController);

	//widgets
	mmWidgets('[data-mm-hotkey]').macifyHotkeys(navigatorShim);

	mmWidgets('body').splittableWidget(mapEditing.splittableModel, mapViewing.mapModel, true);
	if (navigatorShim.isMobile()  && navigatorShim.isTouch()) {
		document.querySelector('body').classList.add('touchdevice');
	}

	mmWidgets('[data-mm-role~="google-share"]').driveShareDialog(navigatorShim, googlePageController, authentication.googleShim, gapiScriptLoader);
	mmWidgets('[data-mm-role="file-name"]').fileNameWidget(googlePageController, fileContextDispatcher);
	mmWidgets('[data-mm-role="moveToFolder"]').moveToFolderWidget(googlePageController, authentication.authenticationModel, googleDriveService, googlePicker);
	mmWidgets('[data-mm-role="copyFileWidget"]').copyFileWidget(copyFileController, googlePageController);
	mmWidgets('[data-mm-role="iconEditorWidget"]').iconEditorWidget(iconEditorController);
	mmWidgets('[data-mm-role="attachmentEditorWidget"]').attachmentEditorWidget(attachmentEditorController);
	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);

	components.domMapController = mapViewing.initialiseWidgets(container);
	mapEditing.initialiseWidgets({
		stage: mmWidgets('[data-mapjs-role=stage]'),
		domMapController: components.domMapController,
		navigatorShim,
		domImageDimensionCalculator,
		urlDownloader: corsProxyFallbackDownloader
	});
	mapExports.initialiseWidgets();
	measures.initialiseWidgets();

	mmWidgets('mapmenu').menuBarWidget(navigatorShim);
	mmWidgets('[data-mm-node-context]').nodeContextWidget(mapViewing.mapModel);
	mmWidgets('a[download]').downloadLinkWidget(navigatorShim);
	mmWidgets('[data-mm-show-hotkey]').showHotkeyWidget(mmWidgets(document));
	mmWidgets('contextmenu[data-mm-role~="node-context"]').contextMenuWidget(contextMenuModel, mmWidgets('mapeditor'), mmWidgets('body'));
	mmWidgets('contextmenu[data-mm-role~="writer-context"]').contextMenuWidget(new ContextMenuModel(writerModel), mmWidgets('#writer'), mmWidgets('body'), {smallContexts: ['contextMenuRequested']});

	mmWidgets('[data-mm-role=keyboard-color]').keyboardColorWidget(mapViewing.mapModel, mapEditing.mapEditorModel, mapViewing.themeProvider);
	mmWidgets('#searchWidget').searchWidget(mapViewing.mapModel);

	// atlas widgets
	mmWidgets('[data-mm-role~="popup-link"]').popupLinkWidget(navigatorShim);
	mmWidgets('[data-mm-role~=selectable-read-only]').selectableReadOnlyInputWidget();
	mmWidgets('tabbedsection').tabbedSectionWidget();
	// end atlas widgets

	mmWidgets('[data-mm-role~=full-screen-view]').fullScreenControlWidget(navigatorShim);

	mmWidgets('[data-mm-sidebar-name]').sidebarWidget(mapEditing.splittableModel);
	mmWidgets('#storyboard').storyboardWidget(storyboardController, storyboardModel, storyboardDimensionProvider, storyboardMapMediator, mapEditing.splittableModel);
	mmWidgets('#writer').writerWidget(writerModel, mapEditing.splittableModel, formatNoteToHtml);

	mmWidgets('[data-mm-install-hotkey]').installHotkeyWidget();
	mmWidgets('[data-mm-context-menu-context]').contextDisablerWidget(contextMenuModel, 'context', 'data-mm-context-menu-context');
	mmWidgets('[data-mm-storyboard-context]').contextDisablerWidget(storyboardController, 'storyboardContext', 'data-mm-storyboard-context');
	mmWidgets('[data-mm-themes-context]').contextDisablerWidget(mapViewing.mapThemeModel, 'themesContext', 'data-mm-themes-context');
	mmWidgets('[data-mm-writer-context]').contextDisablerWidget(writerModel, 'writerContext', 'data-mm-writer-context');
	mmWidgets('[data-mm-file-context]').contextDisablerWidget(fileContextDispatcher, 'fileContext', 'data-mm-file-context');
	mmWidgets('[data-mm-file-context-value]').dispatchedEventValueWidget(fileContextDispatcher, ['fileContext'], 'mm-file-context-value');
	mmWidgets('[data-mm-argument-mapping-context]').contextDisablerWidget(mapEditing.argumentMappingModel, 'argumentMappingContext', 'data-mm-argument-mapping-context');
	mmWidgets('[data-mm-role~=drive-sender]').sendToGoogleDriveWidget(googleDriveService, googlePageController, config.googleDriveUrlPrefix, navigatorShim, ajaxBlobFetch);
	mmWidgets('[data-mm-role~=blob-downloader-link]').blobDownloaderLinkWidget(navigatorShim);
	mmWidgets('[data-mm-role~=blob-tab-loader-link]').blobDownloaderLinkWidget(navigatorShim, true);

	mmWidgets('[data-mm-subscription-profile]').subscriptionProfileWidget(authentication.subscriptionModel);


	mmWidgets('[data-mm-file-save-context]').contextDisablerWidget(unsavedChangesModel, 'fileChangeContext', 'data-mm-file-save-context');

	mmWidgets('[data-mm-role~=file-confirmation]').googleFileConfirmationWidget(googlePageController);

	mmWidgets('mapeditor').storyboardKeyHandlerWidget(storyboardController, storyboardModel, mapViewing.mapModel, '+');

	mmWidgets('[data-mm-keydown-toggle]').keydownToggleWidget();
	mmWidgets('[data-mm-role~=send-activity-log]').sendActivityLogWidget(activityLog);

	clipboard.initialiseWidgets();

	window.setTimeout(googlePageController.start, 100);
	window.components = components;

	window.addEventListener('error', e => {
		activityLog.error(e, 'window');
	});
	activityLog.log('browser', 'info', JSON.stringify(navigatorShim.browserInfo()));
};
